// ------------------------------------
// Constants
// ------------------------------------
// prettier-ignore
export const NETWORK_ROUTES_POST_REQUEST = 'NETWORK_ROUTES_POST_REQUEST';
// prettier-ignore
export const NETWORK_ROUTES_POST_REQUEST_SUCCESS = 'NETWORK_ROUTES_POST_REQUEST_SUCCESS';
// prettier-ignore
export const NETWORK_ROUTES_POST_REQUEST_FAILURE = 'NETWORK_ROUTES_POST_REQUEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: NETWORK_ROUTES_POST_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(data, payload) {
  return {
    type: NETWORK_ROUTES_POST_REQUEST_SUCCESS,
    data,
    payload,
  };
}

export function requestFailure(error) {
  return {
    type: NETWORK_ROUTES_POST_REQUEST_FAILURE,
    error,
  };
}
